const { CARD_CREDIT, CARD_DEBIT, CARD_ECARD } = require('constants/index');

module.exports = {
    credito: CARD_CREDIT,
    debito: CARD_DEBIT,
    ecard: CARD_ECARD
};
